import React from 'react';
import {Navigate} from 'react-router-dom';

/**
 * Catches render/lifecycle errors below it and redirects to /error by default.
 * You can pass a custom fallback via the `fallback` prop if desired.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        // TODO: send to your logging service (Sentry, etc.)
        // Example: Sentry.captureException(error, { extra: info });
        // Always keep a console log for local troubleshooting:
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary caught an error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <Navigate to="/error" replace/>;
        }
        return this.props.children;
    }
}